export const SITE_URL = "https://javian.tech";
export const DEFAULT_IMAGE = `${SITE_URL}/javian_logo2.png`;

export const routesMeta = {
  "/": {
    title: "Personal Website | Javian Anderson",
    description: "Welcome to the website of Javian Anderson!",
    image: DEFAULT_IMAGE,
  },
  "/about": {
    title: "About Page | Javian Anderson",
    description:
      "Javian Anderson's background, certifications, security domains, and tooling.",
    image: DEFAULT_IMAGE,
  },
  "/projects": {
    title: "Projects | Javian Anderson",
    description: "View the projects done by Javian Anderson",
    image: "https://www.icj.org/wp-content/uploads/2015/07/Projects-copy.jpg",
  },
  "/blogs": {
    title: "Blogs | Javian Anderson",
    description: "View the blogs written by Javian Anderson",
    image: "https://neilpatel.com/wp-content/uploads/2018/10/blog.jpg",
  },
  "/how-i-ended-up-doing-computer-science": {
    title: "How I ended up choosing my Major | Javian Anderson",
    description:
      "Transitioning from High School to University gave me a whole lot of decisions to make, but the most important was how I ended up doing Computer Science when it was never an option before.",
    image: "https://i.ibb.co/r0bvmQW/blog1.jpg",
  },
  "/my-entrepreneurial-journey": {
    title: "My Entrepreneurial Journey | Javian Anderson",
    description:
      "Having rediscovered the love I had being around computer and other devices, I had started couple business ventures in my university journey.",
    image: "https://i.ibb.co/LtzNfb2/entrep.png",
  },
  "/2-factor-authentication": {
    title: "What is 2 Factor Authentication? | Javian Anderson",
    description:
      "2FA Unveiled: Exploring Its Benefits and Why You Should Embrace It Online",
    image: "https://i.ibb.co/Bz3yt0n/2fa.jpeg",
  },
  "/digital-forensics-homelab": {
    title: "Digital Forensics HomeLab | Javian Anderson",
    description:
      "A self-hosted Active Directory + forensics range built with virt-manager on Ubuntu.",
    image: DEFAULT_IMAGE,
  },
  "/digital-forensics-homelab-topology": {
    title: "Digital Forensics HomeLab: Network Topology | Javian Anderson",
    description:
      "How the pfSense firewall, domain controller, domain-joined clients, and isolated Kali/CAINE boxes are wired together in the home lab.",
    image: DEFAULT_IMAGE,
  },
  "/digital-forensics-homelab-active-directory": {
    title: "Digital Forensics HomeLab: Active Directory Basics | Javian Anderson",
    description:
      "What Active Directory is, the services that make it work, and the role AD plays in incident response, learned by building it on Windows Server 2022.",
    image: DEFAULT_IMAGE,
  },
  "/digital-forensics-homelab-sysvol": {
    title: "Digital Forensics HomeLab: SYSVOL | Javian Anderson",
    description:
      "What SYSVOL is, why domain controllers are prime targets for attackers, and how SYSVOL gets used for lateral movement.",
    image: DEFAULT_IMAGE,
  },
  "/digital-forensics-homelab-gpos": {
    title: "Digital Forensics HomeLab: Group Policy Objects | Javian Anderson",
    description:
      "What GPOs are and what gets replicated through SYSVOL, how to create one, and building a PowerShell logon script to enforce user-to-machine matching.",
    image: DEFAULT_IMAGE,
  },
  "/digital-forensics-homelab-logging": {
    title: "Digital Forensics HomeLab: Centralized Logging with Loki | Javian Anderson",
    description:
      "Why logging and syslog matter, and how I built a central log collector with rsyslog, Promtail, Grafana Loki, and NXLog for a DFIR home lab.",
    image: DEFAULT_IMAGE,
  },
  "/cases": {
    title: "Digital Forensics Cases | Javian Anderson",
    description:
      "Worked digital forensics investigations from my home lab, each with its scenario, evidence handling, analysis, and case documents.",
    image: DEFAULT_IMAGE,
  },
  "/cases/case-001-cracked-tool-beaconing": {
    title: "Case 001: Simulated Cracked-Tool Download and C2 Beaconing | Javian Anderson",
    description:
      "A planned lab investigation of a simulated cracked-tool download that beacons to a fake C2, investigated from logs, memory, and disk.",
    image: DEFAULT_IMAGE,
  },
};

export function getRouteMeta(routePath) {
  const meta = routesMeta[routePath];
  if (!meta) {
    throw new Error(`No SEO metadata registered for route "${routePath}"`);
  }
  // Netlify serves these routes from <route>/index.html and 301-redirects the
  // bare path to the trailing-slash URL, so the card URL must match that
  // final destination or link-preview bots flag it as redirected.
  const url = routePath === "/" ? SITE_URL : `${SITE_URL}${routePath}/`;
  return { ...meta, url };
}
